import React, { useEffect, useRef, useState } from "react";
import { MdOutlinePlayCircle } from "react-icons/md";
import { useDispatch } from "react-redux";
import useVdocipher from "../hooks/use-vdocipher";
import VideoStatusUsingAPI from "../status/index";
import { addVideo } from "./func";
import "./style.css";

export default function Player({ message, otp, playbackInfo, data }) {
    const { isAPIReady } = useVdocipher();
    const videoContainerRef = useRef();
    const innerPlayerRef = useRef();
    const [videoRef, setVideoRef] = useState(null);
    const [display, setDisplay] = useState("block");
    const [playbackStarted, setPlaybackStarted] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setPlaybackStarted(false);
        setVideoRef(null);
        setDisplay("block");
        videoContainerRef.current?.classList.remove("haveVideo");
    }, [otp, playbackInfo]);

    useEffect(() => {
        if (!playbackStarted || !isAPIReady) {
            if (!playbackStarted) setVideoRef(null);
            return;
        }
        const el = innerPlayerRef.current;
        if (el) setVideoRef(el);
    }, [playbackStarted, isAPIReady, otp, playbackInfo]);

    const showPlayer =
        playbackStarted && isAPIReady && otp && playbackInfo;

    return (
        <div className="hello" style={{ position: "relative" }}>
            <div className="inline">
                <br />
                <button
                    style={{
                        position: "absolute",
                        bottom: "50%",
                        left: "45%",
                        cursor: "pointer",
                        zIndex: "10",
                        background: "white",
                        color: "#0e1f42",
                        borderRadius: "8px",
                        padding: "10px",
                        margin: "2px",
                        display: display,
                    }}
                    onClick={() =>
                        addVideo({
                            otp,
                            playbackInfo,
                            videoContainerRef,
                            setDisplay,
                            dispatch,
                            data,
                            setPlaybackStarted,
                        })
                    }
                >
                    <MdOutlinePlayCircle style={{ fontSize: "50px" }} />
                </button>
            </div>
            <div className="vdo-container" ref={videoContainerRef}>
                {showPlayer ? (
                    <vdocipher-player
                        ref={innerPlayerRef}
                        key={`${otp}:${playbackInfo}`}
                        otp={otp}
                        playbackInfo={playbackInfo}
                        style={{
                            height: "100%",
                            width: "100%",
                            display: "block",
                        }}
                    />
                ) : null}
            </div>
            <VideoStatusUsingAPI
                videoRef={videoRef}
                isAPIReady={isAPIReady}
                videoId={data?.id}
                videoType={data?.video_type}
            />
        </div>
    );
}
